import React, { Component } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

interface Props {
  open: boolean;
  sdata?: any;
  onClose?: () => void;
  onApply?: (model: any) => void;
}

interface State {
  prompt: string;
  preview: any;
}

export default class AIQueryAssistant extends Component<Props, State> {
  state: State = {
    prompt: "",
    preview: null,
  };

  private inferModel = () => {
    const { sdata } = this.props;
    const prompt = this.state.prompt.trim();
    const menuFields = sdata?.menu?.mnu || [];
    const defaultField = sdata?.menu?.def || menuFields[0]?.v || "";
    const lower = prompt.toLowerCase();

    let chosenField = defaultField;
    let chosenLabel = menuFields.find((m: any) => m.v === defaultField)?.t || "";

    for (const field of menuFields) {
      if (
        lower.includes(String(field.t || "").toLowerCase()) ||
        lower.includes(String(field.v || "").toLowerCase())
      ) {
        chosenField = field.v;
        chosenLabel = field.t;
        break;
      }
    }

    const operator =
      lower.includes("starts with") ? "starts" :
      lower.includes("ends with") ? "ends" :
      lower.includes("equals") || lower.includes("exact") ? "equals" :
      "contains";

    const preview = {
      search: prompt,
      defaultField,
      conditions: prompt
        ? [
            {
              id: "ai_1",
              field: chosenField,
              label: chosenLabel,
              operator,
              value: prompt,
            },
          ]
        : [],
    };

    this.setState({ preview });
  };

  private handleApply = () => {
    if (this.state.preview) {
      this.props.onApply?.(this.state.preview);
    }
  };

  render() {
    const { open, onClose, sdata } = this.props;
    const { prompt, preview } = this.state;

    return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
        <DialogTitle>
          <Stack direction="row" spacing={1} alignItems="center">
            <AutoAwesomeIcon fontSize="small" />
            <span>AI Query Assistant</span>
          </Stack>
        </DialogTitle>

        <DialogContent>
          <Stack spacing={2} sx={{ pt: 0.5 }}>
            <Typography sx={{ fontSize: 13, color: "#66788A" }}>
              Describe what you want to find. The assistant will translate it into the same structured filter model used by the grid.
            </Typography>

            <TextField
              multiline
              minRows={3}
              label="Ask in plain language"
              placeholder="Example: show active budget periods with reference FY2025"
              value={prompt}
              onChange={(e) => this.setState({ prompt: e.target.value })}
            />

            <Button variant="outlined" onClick={this.inferModel}>
              Generate Filter Draft
            </Button>

            {preview ? (
              <Box
                sx={{
                  p: 1.5,
                  borderRadius: "10px",
                  border: "1px solid #E2E8EE",
                  bgcolor: "#F8FAFB",
                  fontFamily: "monospace",
                  fontSize: 13,
                  whiteSpace: "pre-wrap",
                }}
              >
                {JSON.stringify(preview, null, 2)}
              </Box>
            ) : null}

            <TextField select label="Allowed query fields" size="small" value="" SelectProps={{ displayEmpty: true }}>
              {(sdata?.menu?.mnu || []).map((item: any) => (
                <MenuItem key={item.v} value={item.v}>
                  {item.t} ({item.v})
                </MenuItem>
              ))}
            </TextField>
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose}>Close</Button>
          <Button variant="contained" onClick={this.handleApply} disabled={!preview}>
            Apply Draft
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
